import { Component, Input } from '@angular/core';
import { OverlayRef } from 'app/shared/ui/overlays';
import { GoogleModule } from '../google';
import { UiModule } from '../ui';


@Component({
    selector: 'share-dialog',
    imports: [
        UiModule,
        GoogleModule,
    ],
    template: `
        <ui-modal size="640">
            <modal-header>
                Download & Share
            </modal-header>
            <modal-body>
                <div class="form-group p-2">
                    <label for="copy">Copy and share PDF as private link. This link will expire in {{ expiration }}:</label>
                    <div class="input-group">
                        <input class="form-control" readonly [value]="pdfLink">
                        <div class="input-group-append">
                            <a [copyLink]="pdfLink" class="btn btn-secondary">
                                Copy <i class="fa fa-copy"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="form-group row px-2 py-3">
                    <div class="col">
                        <a
                            class="card text-center text-dark text-decoration-none active"
                            autofocus
                            [href]="pdfLink"
                            [attr.download]="pdfLink"
                            target="_blank">
                            <img alt="" class="card-img-top pt-3" style="height: 80px" src="/assets/images/share-dialog/pdf.svg">
                            <div class="card-body">
                                Download as PDF
                            </div>
                        </a>
                    </div>
                    <div class="col">
                        <a
                            class="card text-center text-dark text-decoration-none active"
                            [href]="mailtoLink"
                            target="_blank"
                            gaEvent="mailto"
                            [gaAction]="gaEventName">
                            <img alt="" class="card-img-top pt-3" style="height: 80px" src="/assets/images/share-dialog/email.svg">
                            <div class="card-body">
                                Send Private Link to Client
                            </div>
                        </a>
                    </div>
                </div>
            </modal-body>
            <modal-footer>
                <button class="btn btn-secondary" (click)="done()">Done</button>
            </modal-footer>
        </ui-modal>
    `,
})
export class ShareDialogComponent {

    @Input() pdfLink: string;

    @Input() gaEventName = '<undefined>';

    @Input() emailSubject = '';

    @Input() emailBody = '';

    @Input() expiration = '3 months';

    get mailtoLink() {
        return `mailto:?subject=${encodeURIComponent(this.emailSubject)}&body=${encodeURIComponent(this.emailBody)}`;
    }

    constructor(private overlayRef: OverlayRef<'done'>) {}

    done() {
        this.overlayRef.close('done');
    }
}
